var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowSuspend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 113,
    viewBox: "0 0 192 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 19C93 27.6236 86.0092 34.6144 77.3856 34.6144L62.3856 34.6144C52.2315 34.6144 44 42.8459 44 53",
    stroke: "#BEBEBE",
    strokeWidth: 1.67857,
    strokeDasharray: "3.36 3.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93 19C93 27.6236 99.9908 34.6144 108.614 34.6144L124.614 34.6144C134.768 34.6144 143 42.8459 143 53",
    stroke: "#BEBEBE",
    strokeWidth: 1.67857,
    strokeDasharray: "3.36 3.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2846 69.3574C40.2846 74.4664 36.143 78.608 31.0341 78.608L20.9626 78.608C14.947 78.608 10.0703 83.4846 10.0703 89.5003",
    stroke: "#BEBEBE",
    strokeWidth: 1.67857,
    strokeDasharray: "3.36 3.36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.714 69.3574C147.714 74.4664 143.573 78.608 138.464 78.608L128.392 78.608C122.377 78.608 117.5 83.4846 117.5 89.5003",
    stroke: "#BEBEBE",
    strokeWidth: 1.67857,
    strokeDasharray: "3.36 3.36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9635 69.3574C41.9635 74.4664 46.1051 78.608 51.214 78.608L61.2854 78.608C67.3011 78.608 72.1777 83.4846 72.1777 89.5003",
    stroke: "#BEBEBE",
    strokeWidth: 1.67857,
    strokeDasharray: "3.36 3.36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.391 69.3574C149.391 74.4664 153.533 78.608 158.642 78.608L168.713 78.608C174.729 78.608 179.605 83.4846 179.605 89.5003",
    stroke: "#BEBEBE",
    strokeWidth: 1.67857,
    strokeDasharray: "3.36 3.36"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5352,
    y: 45.8574,
    width: 23.5,
    height: 23.5,
    rx: 3.35714,
    fill: "#EB8900"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 89.5,
    width: 23.5,
    height: 23.5,
    rx: 3.35714,
    fill: "#EB8900"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.3926,
    y: 89.5,
    width: 23.5,
    height: 23.5,
    rx: 3.35714,
    fill: "#EB8900"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 104.07,
    y: 89.5,
    width: 23.5,
    height: 23.5,
    rx: 3.35714,
    fill: "#EB8900"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 167.855,
    y: 89.5,
    width: 23.5,
    height: 23.5,
    rx: 3.35714,
    fill: "#EB8900"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 135.963,
    y: 45.8574,
    width: 23.5,
    height: 23.5,
    rx: 3.35714,
    fill: "#EB8900"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.75 3.35714C80.75 1.50305 82.253 0 84.1071 0H100.893C102.747 0 104.25 1.50304 104.25 3.35714V20.1429C104.25 21.997 102.747 23.5 100.893 23.5H84.1071C82.253 23.5 80.75 21.997 80.75 20.1429V3.35714Z",
    fill: "#EB8900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowSuspend);
export default __webpack_public_path__ + "static/media/workflow_suspend.bdd57855af3d238c9675638f59dc788d.svg";
export { ForwardRef as ReactComponent };